/*global addComment*/
import { addComment } from '../case-page';
$('.ts-add-gardenspot-comment').on('click', function () {
    var entityId = $(this).data('actionid');
    addComment(entityId, 'GardenSpot');
});
$('.ts-add-planttype-comment').on('click', function () {
    var entityId = $(this).data('actionid');
    addComment(entityId, 'PlantType');
});
$('#comments-container').on('click', '.ts-delete-comment-garden-spot', function () {
    var commentId = $(this).data('commentid');
    $.post({
        url: '/min-tradgard/vaxtplats/radera-kommentar',
        data: { commentId: commentId, '__RequestVerificationToken': $('.js-anti-forgery' + ' input').val() }
    }).done(function (response) {
        var element = document.getElementById('comment-' + commentId);
        if (element) {
            element.outerHTML = '';
        }
    });
});
$('#comments-container').on('click', '.ts-delete-comment-plant-type', function () {
    var commentId = $(this).data('commentid');
    $.post({
        url: '/min-tradgard/vaxttyp/radera-kommentar',
        data: { commentId: commentId, '__RequestVerificationToken': $('.js-anti-forgery' + ' input').val() }
    }).done(function (response) {
        var element = document.getElementById('comment-' + commentId);
        if (element) {
            element.outerHTML = '';
        }
    });
});
